// extracted by mini-css-extract-plugin
module.exports = {"allProjects":"QuotationsList_allProjects__quEns","emptyState":"QuotationsList_emptyState__2W-sy","emptyStateText":"QuotationsList_emptyStateText__a9MiK"};